export default __webpack_public_path__ + "static/media/recorte_10.2e1c62ee.JPG";